/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fluffy_Game_Mare_WorkInputs */

const fr_fluffy_game_mare_work = /** @type {(inputs: Fluffy_Game_Mare_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter`)
};

/**

* @param {Fluffy_Game_Mare_WorkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fluffy_game_mare_work = /** @type {((inputs?: Fluffy_Game_Mare_WorkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fluffy_Game_Mare_WorkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fluffy_game_mare_work(inputs)
});